import { GlobalMenu } from '@components';
import { NavigationContext } from '@layout/navigation/navigation';
import { AssetContext } from '@pages/Asset/Asset.query';
import { getPermissionData } from '@utils';
import { getProductValue } from '@utils/getProductValue';
import { useContext } from 'react';
import { Container } from './DocumentsMenu.styles';

const DocumentsMenu = () => {
  const { openAddDocument, sortDocumentByFavorite, equipmentQuery } =
    useContext(AssetContext);
  const { role } = useContext(NavigationContext);
  const addPermission = getPermissionData({
    owner: true,
    action: 'add',
    role,
    type: 'Document',
  });

  const equipment = equipmentQuery?.data;
  const { manufacturerId, productId } = getProductValue(equipment);

  const hasProduct = manufacturerId && productId;
  const isEnabled = addPermission.allowed && hasProduct;

  return (
    <Container>
      <GlobalMenu
        align="end"
        title="Options"
        itemList={[
          {
            label: 'Add Document',
            iconName: 'plus',
            disabled: !isEnabled,
            toolTipText: addPermission.message,
            toolTipId: 'addDocumentTooltip',
            onClick: () => {
              if (isEnabled) {
                openAddDocument.set(true);
              }
            },
          },
          {
            label: sortDocumentByFavorite.get()
              ? 'Remove Sort'
              : 'Sort By: Favorite',
            iconName: 'sort-alphabetical',
            onClick: () => {
              sortDocumentByFavorite.set(!sortDocumentByFavorite.get());
            },
          },
        ]}
      />
    </Container>
  );
};

export { DocumentsMenu };
